import React from 'react';
import './SubscriptionImportWizard.css';
// Reuse general wizard overlay/modal styling from AddRechnungWizard
import './projectDetails/AddRechnungWizard.css';
import { SubscriptionImportProvider, useSubscriptionImport } from './subscription/SubscriptionImportContext.tsx';
import SubscriptionStep1File from './subscription/SubscriptionStep1File.tsx';
import SubscriptionStep2Type from './subscription/SubscriptionStep2Type.tsx';
import SubscriptionStep3Match from './subscription/SubscriptionStep3Match.tsx';

interface SubscriptionImportWizardProps {
    onClose?: () => void;
    onImported?: (createdCount: number) => void;
    modal?: boolean;
}

const WizardInner: React.FC<SubscriptionImportWizardProps> = ({ onClose, onImported, modal }) => {
    const {
        currentStep,
        setCurrentStep,
        loading,
        importing,
        canProceedStep1,
        canProceedStep2,
        newSubscriptions,
        handleImport
    } = useSubscriptionImport();

    const getStepStatus = (step: number) => {
        if (step < currentStep) return 'completed';
        if (step === currentStep) return 'active';
        return '';
    };

    const core = (
        <div className="subscription-import-wizard">
            {!modal && (
                <div className="wizard-header">
                    <h1>Abonnements importieren</h1>
                    <div className="wizard-steps">
                        <div className={`wizard-step ${getStepStatus(1)}`}>
                            <span className="step-number">1</span>
                            <span>Datei hochladen</span>
                        </div>
                        <div className={`wizard-step ${getStepStatus(2)}`}>
                            <span className="step-number">2</span>
                            <span>Typ auswählen</span>
                        </div>
                        <div className={`wizard-step ${getStepStatus(3)}`}>
                            <span className="step-number">3</span>
                            <span>Abgleich & Import</span>
                        </div>
                    </div>
                </div>
            )}
            {modal && (
                <div className="wizard-steps" style={{ marginBottom: '20px' }}>
                    <div className={`wizard-step ${getStepStatus(1)}`}>
                        <span className="step-number">1</span>
                        <span>Datei</span>
                    </div>
                    <div className={`wizard-step ${getStepStatus(2)}`}>
                        <span className="step-number">2</span>
                        <span>Typ</span>
                    </div>
                    <div className={`wizard-step ${getStepStatus(3)}`}>
                        <span className="step-number">3</span>
                        <span>Import</span>
                    </div>
                </div>
            )}
            <div className="wizard-content">
                {loading ? (
                    <div className="wizard-loading">Laden...</div>
                ) : (
                    <>
                        {currentStep === 1 && <SubscriptionStep1File />}
                        {currentStep === 2 && <SubscriptionStep2Type />}
                        {currentStep === 3 && <SubscriptionStep3Match />}
                    </>
                )}
            </div>
            <div className="wizard-navigation">
                <button
                    className="wizard-btn secondary"
                    onClick={() => {
                        if (currentStep === 1) { if (onClose) onClose(); }
                        else { setCurrentStep(s => s - 1); }
                    }}
                    disabled={loading || importing}
                >
                    {currentStep === 1 ? 'Abbrechen' : 'Zurück'}
                </button>
                {currentStep < 3 ? (
                    <button
                        className="wizard-btn primary"
                        onClick={() => setCurrentStep(s => s + 1)}
                        disabled={
                            loading ||
                            (currentStep === 1 && !canProceedStep1) ||
                            (currentStep === 2 && !canProceedStep2)
                        }
                    >
                        Weiter
                    </button>
                ) : (
                    <button
                        className="wizard-btn success"
                        onClick={() => handleImport(onImported, onClose)}
                        disabled={importing || newSubscriptions.filter(s => s.selected).length === 0}
                    >
                        {importing ? 'Importiere...' : 'Importieren'}
                    </button>
                )}
            </div>
        </div>
    );
    if (!modal) return core;

    return (
        <div className="wizard-overlay" onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}>
            <div className="wizard-modal wizard-modal-large">
                <div className="wizard-header">
                    <h2>Abonnements importieren</h2>
                    <button className="wizard-close-btn" onClick={() => onClose && onClose()} aria-label="Schließen">✕</button>
                </div>
                {core}
            </div>
        </div>
    );
};

const SubscriptionImportWizard: React.FC<SubscriptionImportWizardProps> = (props) => {
    return (
        <SubscriptionImportProvider>
            <WizardInner {...props} />
        </SubscriptionImportProvider>
    );
};

export default SubscriptionImportWizard;
